import { formatInTimeZone } from 'date-fns-tz';

export const formatDateTime = (date: string | Date, formatSchema = 'dd/MM/yyyy') => {
  if (!date) return;
  return formatInTimeZone(date, 'America/Sao_Paulo', formatSchema);
};

export const formatBirthdate = (birthdate: string) => {
  const [year, month, day] = birthdate.split('-');

  return `${day}/${month}/${year}`;
};
